/*jslint node: true, todo: true*/
"use strict";

var $ = require("pli/jquery");
var ko = require("pli/knockout");
var pli = require("pli/forms");
var KnockoutDataProvider = require("pli/data-provider/knockoutDataProvider").KnockoutDataProvider;
var R = require("ramda");

var dataCache = require("../datacache");

require("../picklist-common");

var registry = {},
    reportDefaults = { width: 820, height: 630 },
    contextMenuNotifier = $.Callbacks();


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Private
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function parseId(data, preferName) {
    var id = preferName
        ? (data && (data.uniqueName || data.id))
        : (data && (data.id || data.uniqueName));
    return id || data || "";
}

//-------------------------------------------
function deleteActionHandler(settings) {
    settings = settings || {};
    pli.viewModel.contentDeleteForm.open({ displayName: settings.uniqueName || settings.id, id: settings.guid || settings.id });
}


//--------------------------------------------------
function reportStartHandler(response) {
    /// <summary>
    ///  Handles start percent and status call response
    ///  Expects response.result.token on success, or response.result.statusDescription on error
    /// </summary>
    if (!response.isError && response.result) {
        pli.dialog.open({ targetUrl: "~~/Reports/Generate#" + response.result.token, width: 1000, height: 700, windowType: "window" });
    }
}

//-------------------------------------------
function buildSearchResultOpener(settings) {
    var width = (settings && settings.width) || 1000,
        height = (settings && settings.height) || 700,
        url;
    return function (value) {
        if (value && value.url) {
            url = value.url;
            height = (value.data && value.data.height) || height;
            width = (value.data && value.data.width) || width;
        } else if (value.data) {
            url = value.data[value.data.length - 2];
        }
        return (url
            ? pli.dialog.open({ targetUrl: url, width: width, height: height, windowType: "window", resizable: true})
            : false);
    };
}

//-------------------------------------------
function buildReportOpener(settings) {
    var width = (settings && settings.width) || reportDefaults.width,
        height = (settings && settings.height) || reportDefaults.height,
        url;

    return function (value) {
        if (value) {
            // Extract url
            if (value.url) {
                url = value.url;
            } else if (value.data) {
                url = value.data.url;
            }

            if (value.data) {
                if (value.data.autorun) {
                    // Set the report title to be used in the child report window
                    pli.reportTitle = value.data.name;

                    // start report
                    return pli.call({
                        name: "Geo-Report-Start",
                        data: { reportId: value.data.type, reportData: ko.toJSON(value.data) }
                    }).always(reportStartHandler);
                }
                if (url) {
                // If report to be opened are "CustomExport" or "WellImport", just open them, no need for modal form
                    if (value.data.type === "CustomExport" || value.data.type === "WellImport") {
                        return pli.dialog.open({ targetUrl: url, width: width, height: height, windowType: "window", resizable: true });
                    }
                    // Displays report action form where user can select existing saved presets
                    // copy saved presets or open last run
                    return pli.forms.registry.reportActionForm.open(value.data);
                }
            }
        }

        return false;
    };
}

//-------------------------------------------
function buildDocumentPrintHandler(reportType) {
    return function open(data) {
        var docId = parseId(data, true);

        if (pli.viewModel && pli.viewModel.extras && pli.viewModel.extras.title) {
            pli.reportTitle = pli.viewModel.extras.title();
        } else {
            pli.reportTitle = reportType;
        }

        // start report
        pli.call({
            name: "Geo-Report-Start",
            data: { reportId: reportType, reportData: ko.toJSON({ id: docId }) }
        }).always(reportStartHandler);
    };
}

//-------------------------------------------
function buildAddToProjectWindowHandler() {
    return function open(documentsToAdd) {
        var docs = documentsToAdd;
        // ignore case when searching and search the project name column (index 0)
        var dataProvider = new KnockoutDataProvider(dataCache.getObservable("project"), { exactMatchIgnoresCase: true, searchIndex: 0 });
        pli.forms.registry.picklistForm.open({
            dataProvider: dataProvider,
            value: function (project) {
                if (project !== undefined) {
                    var projectData = {
                        id: project[0][0],
                        guid: project[0][2],
                        projectItems: docs
                    };
                    pli.forms.registry.busyIndicator.open({
                        title: "Adding items, please wait..."
                    });
                    pli.call({
                        name: "Geo-Project-AddItems",
                        data: projectData
                    }).always(function addItemsResult(response) {
                        if (response.isError) {
                            var message = (response && response.message) || "Unable to add project items";
                            pli.forms.registry.busyIndicator.complete({
                                failed: true,
                                message: message,
                                title: "Unable to add project items",
                                onClosed: this.close
                            });
                        } else {
                            pli.forms.registry.busyIndicator.close({ force: true });
                        }
                    });
                }
            }
        });
    };
}


//-------------------------------------------
function buildPicklistOpen(picklistInfo) {
    /// <summary>
    /// Initializes the picklist entity
    /// with behaviour data (for picklist behaviour),
    /// icon and open actions.
    /// </summary>
    var defaultData = {
        hasCategory: !!picklistInfo.hasCategory,
        categoryName: picklistInfo.categoryName,
        type: picklistInfo.type,
        typeDisplayName: picklistInfo.displayName || picklistInfo.type || ""
    },
        edit = function editPicklist(settings) {
            var data = (settings && settings.data) || settings;

            // Add logic to extract the array of array from multi-select picklist
            // Check to see if data[0] is an array and extract that out
            var item = ((data !== undefined) && (Object.prototype.toString.call(data[0]) === '[object Array]'))
                ? data[0]
                : data;

            item = item || [];
            return pli.forms.registry.picklistItemForm.viewModel.open($.extend({
                guid: item.guid || (item[item.length - 1]) || "",
                code: item.code || (item[0]) || "",
                description: item.description || (item[1]) || "",
                category: item.category || (item.length > 3 && item[2]) || ""
            }, defaultData));
        };
    return $.extend({
        getPicklistBehaviourData: function getBehaviourData() {
            return {
                onNewItem: edit,
                onOpenItem: edit,
                picklistData: dataCache.getObservable(picklistInfo.dataCacheId)
            };
        },
        icon: { small: "sprite-editDocument-16" },
        open: {
            create: edit,
            edit: edit,
            remove: deleteActionHandler
        }
    }, picklistInfo);
}


//-------------------------------------------
function projectPrintHandler(data) {
    var localData = data;
    // ignore case when searching and search the project name column (index 0)
    var dataProvider = new KnockoutDataProvider(dataCache.getObservable("projectPrintStyle"), { exactMatchIgnoresCase: true, searchIndex: 0 });
    // TODO: put a nicer hook into Pli for the button text
    pli.forms.registry.picklistForm.$form.find('#picklistForm_buttonBar_accept>span').text('Print');
    pli.forms.registry.picklistForm.open({
        dataProvider: dataProvider,
        value: function (printStyle) {
            if (printStyle !== undefined) {
                pli.config.entityRegistry.project.open.printers[printStyle[0][0]](localData);
            }
            // TODO: remove this after hook exists
            pli.forms.registry.picklistForm.$form.find('#picklistForm_buttonBar_accept>span').text('Accept');
        }
    });
}

//-------------------------------------------
function showContext(data) {
    if (data.id && data.e && data.entityId) {
        contextMenuNotifier.fire(data.e, data);
    }
}

//-------------------------------------------
// context menu item click handler
function onItemCommand(item, command) {
    var entity;
    if (command && item.id && item.entityId) {
        entity = pli.config.entityRegistry[item.entityId];

        if (entity) {
            switch (command) {
            case "deleteId":
                if (entity.open && entity.open.remove) {
                    entity.open.remove(item);
                }
                break;
            case "editId":
                if (entity.open && entity.open.edit) {
                    entity.open.edit(item);
                }
                break;
            case "printId":
                if (entity.open && entity.open.print) {
                    entity.open.print(item);
                }
                break;
            case "removeFavoriteId":
                pli.call({ name: "Geo-Favorites-Remove", data: item.id }); //We don't implement done or fail because we won't yet provide feedback to the user
                break;
            case "addFavoriteId":
                pli.call({ name: "Geo-Favorites-Add", data: item.id }); //We don't implement done or fail because we won't yet provide feedback to the user
                break;
            case "addToProjectId":
                if (entity.open && entity.open.addToProject) {
                    // Multiple items are selected
                    if (item.selectedItems && item.selectedItems.length) {
                        var documents = [];

                        // Build object needed to add to project
                        ko.utils.arrayForEach(item.selectedItems, function (selectedItem) {
                            documents.push({
                                id: selectedItem.id,
                                classId: selectedItem.classId,
                                guid: selectedItem.guid,
                                type: selectedItem.entityName
                            });
                        });

                        entity.open.addToProject(documents);
                    } else {
                        // Focused item selected
                        entity.open.addToProject([
                            {
                                id: item.uniqueName,
                                classId: entity.typeId,
                                guid: item.id,
                                type: item.entityId
                            }
                        ]);
                    }
                }
                break;
            }
        }
    }
}


//-------------------------------------------
// Return a function that will open a new window
// with specified dimensions and pointing at
// the specified URL. ID will be appended to
// the specified URL as a hash segment (url#id).
function createNavigableWindowOpener(url, forcedId, width, height, dialogIdPrefix) {
    return function openNavigableWindow(data) {
        var id = (typeof forcedId === "string" ? forcedId : (data && (data.uniqueName || data.id)) || ""),
            customUrl = data && data.url,
            dialogId = (id && dialogIdPrefix ? dialogIdPrefix + id : null);
        pli.dialog.open({
            targetUrl: url.concat("#").concat(customUrl || encodeURIComponent(id)),
            width: width || 1000,
            height: height || 700,
            windowType: "window",
            id: dialogId
        });
    };
}

//-------------------------------------------
// Return a function that will open a new report window
// for the particular report type and report id
function createReportCriteriaWindowOpener(width, height, defaultUrl, dialogIdPrefix) {
    return function openNavigableWindow(value) {
        var id = (value && value.uniqueName) || (value && value.data && (value.data.reportName || value.data.id)) || "",
            url = (value && value.url) || (value.data && value.data.reportType && defaultUrl.concat("/").concat(value.data.reportType)) || "",
            dialogId = (id && dialogIdPrefix && (value && value.data && value.data.reportType) ? dialogIdPrefix + value.data.reportType + "-" + id : null);
        pli.dialog.open({
            targetUrl: url.concat("#").concat(encodeURIComponent(id)),
            width: width || 1000,
            height: height || 700,
            windowType: "window",
            id: dialogId
        });
    };
}


//-------------------------------------------
// Setup entity context menu
if (pli.menu && pli.menu.setup) {
    pli.menu.setup({
        notifier: contextMenuNotifier,
        itemsCallData: function (content) {
            return {
                name: "Geo-ContextMenu-Get",
                data: {
                    contentGuid: content.id,
                    menuId: "menuGeoContext",
                    rootPath: pli.global.config.rootPath,
                    multipleSelection: (content.selectedItems && content.selectedItems.length > 1) // If multiple selection, display only "Add to Project" option
                }
            };
        },
        click: function (menuItem, content) { onItemCommand(content, menuItem.name()); }
    });
}


//-------------------------------------------
// Creates contactsWithGroups to pass to multiselect
// ko.observablePliTextBox(null, pli.config.entityRegistry.contactsWithGroups, "multiselect");
function buildContactsWithGroups() {

    function ContactsWithGroups() {

        var picklistObservable = dataCache.getObservable("contact"),
            data = picklistObservable().data;

        this.picklistData = ko.observable({ data: data });

        // add groups if cache is already loaded
        if (data) {
            this._addGroups();
        }

        // add group on data change
        picklistObservable.subscribe(ContactsWithGroups.prototype._addGroups, this);
    }

    //-------------------------------------------
    // Adds group to contacts pickList
    ContactsWithGroups.prototype._addGroups = function addGroups() {
        var pickListData = (dataCache.getObservable("contact")()) ? dataCache.getObservable("contact")().data : null,
            data,
            group,
            usGroup,
            us = [],
            notUs = [];

        if (!pickListData || !pickListData.items) {
            return;
        }

        data = $.extend(true, {}, pickListData);
        group = data.items[0].length.toString();
        usGroup = (data.items[0].length + 1).toString();

        // groups already added
        if (data.groups[group] && data.groups[usGroup]) {
            return;
        }

        data.groups[group] = [{ name: "US" }, { name: "ANYONE BUT US" }];
        data.groups[usGroup] = [{ name: "US" }];

        $.each(data.items, function (index, value) {
            if (value[5] === "true") {
                this[group] = data.groups[group][0].name;
                this[usGroup] = data.groups[usGroup][0].name;
                us.push(index);
            } else {
                this[group] = data.groups[group][1].name;
                notUs.push(index);
            }
        });

        data.indices[group] = us.concat(notUs);
        data.indices[usGroup] = us;

        this.picklistData({ data: data });
    };

    return { picklistData: new ContactsWithGroups(), category: "9" };
}


function buildFilterPicklistData(filterPicklistInfo) {

    function FilterPicklist() {

        var picklistObservable = dataCache.getObservable(filterPicklistInfo.dataCacheId),
            data = picklistObservable().data;

        this.picklistData = ko.observable({ data: data });

        if (data) {
            this._filterPicklist();
        }

        // Filter on data change
        picklistObservable.subscribe(FilterPicklist.prototype._filterPicklist, this);
    }

    //-------------------------------------------
    // Filter the picklist based on isGroup property
    FilterPicklist.prototype._filterPicklist = function filterPicklistData() {
        var plData = (dataCache.getObservable(filterPicklistInfo.dataCacheId)()) ? dataCache.getObservable(filterPicklistInfo.dataCacheId)().data : null;

        if (!plData || !plData.items) {
            return;
        }

        var filteredData = ko.utils.arrayFilter(plData.items, filterPicklistInfo.applyFilter);

        var plDataClone = R.clone(plData);

        // Update the items, count and name
        plDataClone.items = filteredData;
        plDataClone.count = filteredData.length;
        plDataClone.name = filterPicklistInfo.displayName;

        this.picklistData({ data: plDataClone, name: filterPicklistInfo.name });
    };

    return new FilterPicklist();
}


//-------------------------------------------
function fillOwnerCompanyNames(o, isSingleSelect) {
    var picklistContact = dataCache.get("contact");

    picklistContact
        .done(function (picklistData) {
            var data = picklistData.data,
                ownerCompanies,
                ownerCompanyNames;

            if (!data || !data.items) {
                return;
            }

            ownerCompanies = ko.utils.arrayFilter(data.items, function (item) {
                return (item[5]); // IsOwner property
            });

            if (isSingleSelect) {
                o.load(ownerCompanies.length === 1 ? ownerCompanies[0][0] : null); // load null if owner companies more than 1
            } else {

                ownerCompanyNames = ko.utils.arrayMap(ownerCompanies, function (company) {
                    return company[0]; // Company code property
                });
                o.load(ownerCompanyNames);
            }
        });
}

//-------------------------------------------
function setCategoryGroup(o, picklistType, categoryGroupNames) {
    var picklist = dataCache.get(picklistType);

    picklist
        .done(function (picklistData) {
            var data = picklistData.data,
                categoryGroupItems,
                categoryCodes;

            if (!data || !data.items) {
                return;
            }

            categoryGroupItems = ko.utils.arrayFilter(data.items, function (item) {
                return (categoryGroupNames.indexOf(item[2]) > -1); // Filter category
            });

            categoryCodes = ko.utils.arrayMap(categoryGroupItems, function (item) {
                return item[0]; // Code property
            });

            o.load(categoryCodes);
        });

    return picklist;
}


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Public
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
registry = {

    //-------------------------------------------
    acquisitionMethod: buildPicklistOpen({ dataCacheId: "acquisitionMethod", type: "Acquisition Method", typeId: "8b9db083-9b2a-4377-b1e3-fb9fa7030954" }),

    //-------------------------------------------
    amendmentType: buildPicklistOpen({ dataCacheId: "amendmentType", type: "Amendment Type", typeId: "49a9aeb1-cfda-4af9-92db-ddad7577e847" }),

    //-------------------------------------------
    area: { // create/edit are assigned via AreaViewModel.js
        icon: { small: "sprite-editDocument-16" },
        open: { remove: deleteActionHandler },
        type: "Area",
        typeId: "0871C209-E3AD-4D07-995F-CF468556EC15"
    },

    //-------------------------------------------
    businessArea: buildPicklistOpen({ dataCacheId: "businessArea", type: "Business Area", displayName: "Business Area" }),

    //-------------------------------------------
    contact: { // create/edit are assigned via ContactViewModel.js
        icon: { small: "sprite-editDocument-16" },
        open: { remove: deleteActionHandler },
        type: "Contact",
        typeId: "4B1ADE3C-DB6C-4EDA-80DE-B014A6E9EEAB"
    },

    contactsWithGroups: buildContactsWithGroups(),

    //-------------------------------------------
    contract: {
        open: {
            create: createNavigableWindowOpener("~~/Contract", null, 1035, null, "contract-"),
            context: showContext,
            edit: createNavigableWindowOpener("~~/Contract", null, 1035, null, "contract-"),
            print: buildDocumentPrintHandler("ContractAbstract"),
            remove: deleteActionHandler,
            addToProject: buildAddToProjectWindowHandler()
        },
        icon: {
            small: "sprite-forms-16",
            medium: "sprite-forms-32"
        },
        type: "Contract",
        typeId: "4D07D189-AEBA-4261-97DF-A6E05E824A21",
        createHint: "Enter a unique contract file number",
        createFileNumberHint: "e.g. C0042 (required)"
    },

    //-------------------------------------------
    contractSplit: {
        icon: { small: "sprite-split-16" },
        open: { edit: buildSearchResultOpener({ width: 1035 }) }
    },

    //-------------------------------------------
    contractSplitLand: {
        icon: { small: "sprite-land-16" },
        open: { edit: buildSearchResultOpener({ width: 1035 }) }
    },

    //-------------------------------------------
    contractStatus: buildPicklistOpen({ dataCacheId: "contractStatus", type: "Contract Status", hasCategory: true, categoryName: "documentStatusCategory", typeId: "587a4437-abbb-4182-a9f7-cd6daa57e222" }),

    //-------------------------------------------
    contractTerm: buildPicklistOpen({ dataCacheId: "contractTerm", type: "Contract Term", displayName: "Contract Term", typeId: "bf28092c-8459-47ba-ac22-225806d4fcdf" }),

    //-------------------------------------------
    contractType: buildPicklistOpen({ dataCacheId: "contractType", type: "Contract Type", displayName: "Contract Type", typeId: "004b7911-ecfe-43a4-a877-55d225e60178" }),

    //-------------------------------------------
    country: buildPicklistOpen({ dataCacheId: "country", type: "Country", typeId: "37ba304e-890b-4ce8-824b-5d39ed6b35bf" }),

    //-------------------------------------------
    exports: {
        displayName: "Export",
        icon: { small: "sprite-export-16" },
        open: { edit: buildReportOpener(reportDefaults) },
        typeId: "54099717-10AD-4F94-AA0B-FB27C63C3228"
    },

    //-------------------------------------------
    externalContractType: buildPicklistOpen({ dataCacheId: "externalContractType", type: "External Contract Type", displayName: "External Contract Type", typeId: "6b38f2aa-25f4-44a9-b4ee-dba860aeba13" }),

    //-------------------------------------------
    favorites: {
        displayName: "Favorite",
        open: {
            addToProject: buildAddToProjectWindowHandler()
        }
    },

    //-------------------------------------------
    file: {
        icon: { small: "sprite-editDocument-16" },
        open: {
            edit: buildSearchResultOpener({ width: 1035 }),
            upload: function (splitId) {
                return pli.dialog.open({
                    targetUrl: "~~/fileupload/".concat(splitId),
                    width: 611,
                    height: 480,
                    windowType: "modal"
                });
            }
        }
    },

    //-------------------------------------------
    formation: {
        open: function (suffix) {
            var targetUrl = "http://formationfinder.com/";

            if (suffix) {
                targetUrl += suffix;
            }

            pli.dialog.open({ targetUrl: targetUrl, width: 1000, height: 700, windowType: "window", resizable: true });
        }
    },

    //-------------------------------------------
    // Remark: Use this instead of the one in datacache as this one remove the "None" item
    fromZoneQualifier: buildFilterPicklistData({ dataCacheId: "fromZoneQualifier", displayName: "From Qualifier", name: "fromZoneQualifier", applyFilter: function (item) { return (item[0] !== "None"); } }),

    //-------------------------------------------
    help: {
        show: function (options) {
            if (!options || typeof options === "string") {
                options = {
                    url: options
                };
            }
            pli.dialog.open({
                targetUrl: options.url || pli.global.resolveUrl("~/Support/GeoNexus"),
                windowType: "window",
                top: 5,
                left: 5
            });
        },
        type: "Help"
    },

    //-------------------------------------------
    imports: {
        displayName: "Import",
        icon: { small: "sprite-import-16" },
        open: { edit: buildReportOpener(reportDefaults) },
        typeId: "8D396E3D-71FA-4120-B3C4-F02BE7D5889C"
    },

    //-------------------------------------------
    interestType: buildPicklistOpen({ dataCacheId: "interestType", type: "Interest Type", hasCategory: true, categoryName: "interestTypeCategory", typeId: "707fd7b9-39d4-4cc6-bdc7-14cfa12de60e" }),

    //-------------------------------------------
    leaseStatus: buildPicklistOpen({ dataCacheId: "leaseStatus", type: "Lease Status", hasCategory: true, categoryName: "documentStatusCategory", typeId: "3eb4a639-7b0a-46e4-96b6-d800f9740f83" }),

    //-------------------------------------------
    legacy: {
        getDialogLoader: function getDialogLoader(url, sourceId) {
            /// <summary>
            /// </summary>

            var base = url, sourceIdRegex = new RegExp("".concat(sourceId).concat("\/?"), "i");

            // remove source guid (it could change)
            base = base.replace(sourceIdRegex, "");

            // append leading slash
            if (base.substr(0, 1) !== "/") {
                base = "/".concat(base);
            }

            // append trailing slash
            if (base.substr(base.length - 1) !== "/") {
                base = base.concat("/");
            }

            return function loader(id, type, targetId, width, height, navItemToSelect) {
                var result = base;
                result = result.concat(id).concat("/").concat(type);
                if (typeof targetId === "string" && targetId.length === 36) {
                    result = result.concat("/").concat(targetId);
                }
                return pli.dialog.open({
                    width: (typeof width === "number" ? width : 625),
                    height: (typeof height === "number" ? height : 545),
                    resizable: true,
                    windowType: "modal",
                    dialogId: "".concat(type).concat("-").concat(targetId || "new"),
                    useLoader: false,
                    targetUrl: result,
                    navItem: navItemToSelect
                });
            };
        }
    },

    //-------------------------------------------
    legalDescription: {
        open: {
            addToProject: buildAddToProjectWindowHandler()
        }
    },

    //-------------------------------------------
    mineralLease: {
        open: {
            create: createNavigableWindowOpener("~~/MineralLease", null, 1035, null, "mineralLease-"),
            context: showContext,
            edit: createNavigableWindowOpener("~~/MineralLease", null, 1035, null, "mineralLease-"),
            print: buildDocumentPrintHandler("MineralLeaseAbstract"),
            remove: deleteActionHandler,
            addToProject: buildAddToProjectWindowHandler()
        },
        icon: {
            small: "sprite-mineralLease-16",
            medium: "sprite-mineralLease-32"
        },
        type: "Mineral Lease",
        typeId: "F22F76ED-99AE-4814-8FD7-4FAAE46FD8A9",
        createHint: "Enter a unique mineral lease file number",
        createFileNumberHint: "e.g. L0042 (required)"
    },

    //-------------------------------------------
    mineralLeaseSplit: {
        icon: { small: "sprite-split-16" },
        open: { edit: buildSearchResultOpener({ width: 1035 }) }
    },

    //-------------------------------------------
    mineralLeaseSplitLand: {
        icon: { small: "sprite-land-16" },
        open: { edit: buildSearchResultOpener({ width: 1035 }) }
    },

    //-------------------------------------------
    mineralLeaseType: buildPicklistOpen({ dataCacheId: "mineralLeaseType", type: "Mineral Lease Type", typeId: "bca9c498-327a-4250-aee7-8ca54ef40e9b" }),

    //-------------------------------------------
    obligationType: buildPicklistOpen({ dataCacheId: "obligationType", type: "Obligation Type", typeId: "5ada76db-faaf-4351-9d21-ced7b2965e80" }),

    //-------------------------------------------
    organizationalLevel: buildPicklistOpen({ dataCacheId: "organizationalLevel", type: "Organizational Level", displayName: "Organizational Level" }),

    //-------------------------------------------
    // NOTE: This is temporary to set the "US" group for company picklist until
    // https://github.com/pandell/web-pli/issues/11 is resolved
    fillOwnerCompanies: fillOwnerCompanyNames,

    //-------------------------------------------
    payorPayee: {
        open: {
            addToProject: buildAddToProjectWindowHandler()
        }
    },

    //-------------------------------------------
    personResponsible: buildPicklistOpen({ dataCacheId: "personResponsible", type: "Person Responsible", typeId: "96431a88-2213-4f98-a7da-94b4cab86635" }),

    //-------------------------------------------
    position: buildPicklistOpen({ dataCacheId: "position", type: "Position", displayName: "Position" }),

    //-------------------------------------------
    project: {
        open: {
            create: createNavigableWindowOpener("~~/Project", null, 1035, null, "project-"),
            context: showContext,
            edit: createNavigableWindowOpener("~~/Project", null, 1035, null, "project-"),
            print: projectPrintHandler,
            printers: {
                Summary: buildDocumentPrintHandler("ProjectSummary"),
                MineralLeaseAbstracts: buildDocumentPrintHandler("ProjectMineralLeaseAbstract"),
                WellAbstracts: buildDocumentPrintHandler("ProjectWellAbstract"),
                ContractAbstracts: buildDocumentPrintHandler("ProjectContractAbstract"),
                SurfaceLeaseAbstracts: buildDocumentPrintHandler("ProjectSurfaceLeaseAbstract")
            },
            remove: deleteActionHandler
        },
        icon: {
            small: "sprite-project-16",
            medium: "sprite-project-32"
        },
        type: "Project",
        typeId: "E6964647-EB54-4D8F-B313-B281B12A2400"
    },

    //-------------------------------------------
    provinceState: { // create/edit are assigned via ProvinceStateViewModel.js
        icon: { small: "sprite-editDocument-16" },
        open: { remove: deleteActionHandler },
        type: "Province-State",
        typeId: "0DE9688C-8931-4971-9F31-67B3611298A6"
    },

    //-------------------------------------------
    provisionCriteria: {
        open: function () {
            pli.dialog.open({ targetUrl: "~~/Reports/ProvisionSearchExport", width: reportDefaults.width, height: reportDefaults.height, windowType: "window" });
        }
    },

    //-------------------------------------------
    provisionType: buildPicklistOpen({ dataCacheId: "provisionType", type: "Provision Type", hasCategory: true, categoryName: "provisionTypeCategory" }),

    //-------------------------------------------
    recentlyRun: {
        displayName: "Recently Run",
        icon: { small: "sprite-clock-16" },
        open: {
            edit: function (value) {
                pli.download(value.data.fileId);
            }
        },
        type: "Recently Run",
        typeId: "26026E42-AE38-4791-8918-94C9171C5931"
    },

    //-------------------------------------------
    reports: {
        displayName: "Report",
        icon: { small: "sprite-report-16" },
        open: { edit: buildReportOpener(reportDefaults) },
        typeId: "C66D5053-80CE-4C71-8858-29ACBFC8B192"
    },

    //-------------------------------------------
    right: {
        open: {
            addToProject: buildAddToProjectWindowHandler()
        }
    },

    //-------------------------------------------
    rightsProduct: buildPicklistOpen({ dataCacheId: "rightsProduct", type: "Rights Product", typeId: "066301a4-ceaa-4d6d-bf28-45b1156647eb" }),


    //-------------------------------------------
    rightsProductBase: buildFilterPicklistData({ dataCacheId: "rightsProduct", displayName: "Rights Product Base", name: "rightsProductBase", applyFilter: function (item) { return (item[2] !== "true"); } }),


    //-------------------------------------------
    royaltyType: buildPicklistOpen({ dataCacheId: "royaltyType", type: "Royalty Type", typeId: "c1d3bb41-01c0-41d3-8499-121d114d4f64" }),

    //-------------------------------------------
    savedPresets: {
        displayName: "Saved Presets",
        icon: { small: "sprite-save-16" },
        open: {
            edit: createReportCriteriaWindowOpener(reportDefaults.width, reportDefaults.height, "~~/Reports", "reports-"),
            remove: deleteActionHandler
        },
        type: "Saved Presets",
        typeId: "741EB758-E34E-42F3-A6DF-5A947D631C03"
    },

    //-------------------------------------------
    searchAll: {
        open: {
            remove: deleteActionHandler,
            addToProject: buildAddToProjectWindowHandler()
        }
    },

    //-------------------------------------------
    setCategoryGroup: setCategoryGroup,

    //-------------------------------------------
    setting: { // create/edit are assigned via settingsViewModel.js
        icon: { small: "sprite-configure-16" },
        open: { },
        type: "Setting",
        typeId: "314534F6-5A7E-43ED-A6E2-56C44E7B6CB1"
    },

    //-------------------------------------------
    splitStatus: buildPicklistOpen({ dataCacheId: "splitStatus", type: "Split Status", hasCategory: true, categoryName: "splitStatusCategory", typeId: "901FB8AC-5C88-4CC6-8BC3-8138F0D0C57F" }),

    //-------------------------------------------
    surfaceLease: {
        open: {
            create: createNavigableWindowOpener("~~/SurfaceLease", null, 1035, null, "surfaceLease-"),
            context: showContext,
            edit: createNavigableWindowOpener("~~/SurfaceLease", null, 1035, null, "surfaceLease-"),
            print: buildDocumentPrintHandler("SurfaceLeaseAbstract"),
            remove: deleteActionHandler,
            addToProject: buildAddToProjectWindowHandler()
        },
        icon: {
            small: "sprite-surfaceLease-16",
            medium: "sprite-surfaceLease-32"
        },
        type: "Surface Lease",
        typeId: "9FA4C840-49AD-408A-AC0F-198DF04B9596",
        createHint: "Enter a unique surface lease file number",
        createFileNumberHint: "e.g. E0042 (required)"
    },

    //-------------------------------------------
    surfaceLeaseSplit: {
        icon: { small: "sprite-split-16" },
        open: { edit: buildSearchResultOpener({ width: 1035 }) }
    },

    //-------------------------------------------
    surfaceLeaseSplitLand: {
        icon: { small: "sprite-land-16" },
        open: { edit: buildSearchResultOpener({ width: 1035 }) }
    },

    //-------------------------------------------
    surfaceLeaseType: buildPicklistOpen({ dataCacheId: "surfaceLeaseType", type: "Surface Lease Type", hasCategory: true, categoryName: "surfaceLeasetypeCategory", typeId: "4f2779d0-aec6-4df0-ae84-3d1cfa337eae" }),

    //-------------------------------------------
    titleEventType: buildPicklistOpen({ dataCacheId: "titleEventType", displayName: "Title Event Type", type: "Title Event Type", typeId: "a29af8e6-8a8d-4c5c-b9aa-8d1807e9111c" }),

    //-------------------------------------------
    // Remark: Use this instead of the one in datacache as this one remove the "None" item
    toZoneQualifier: buildFilterPicklistData({ dataCacheId: "toZoneQualifier", displayName: "To Qualifier", name: "toZoneQualifier", applyFilter: function (item) { return (item[0] !== "None"); } }),

    //-------------------------------------------
    user: {
        icon: { small: "sprite-formalUserBlue-16" },
        open: {
            create: createNavigableWindowOpener("~~/user", null, 1035, null, "user-"),
            edit: createNavigableWindowOpener("~~/user", null, 1035, null, "user-")
        },
        typeId: "304F56E7-CBB4-49AA-8113-1EA6A4650396",
        type: "User"
    },

    //-------------------------------------------
    well: {
        open: {
            create: createNavigableWindowOpener("~~/Well", null, 1035, null, "well-"),
            context: showContext,
            edit: createNavigableWindowOpener("~~/Well", null, 1035, null, "well-"),
            print: buildDocumentPrintHandler("WellAbstract"),
            remove: deleteActionHandler,
            addToProject: buildAddToProjectWindowHandler()
        },
        icon: {
            small: "sprite-well-16",
            medium: "sprite-well-32"
        },
        type: "Well",
        typeId: "181296AD-1A78-4DDA-BDFF-F54D188B95EB"
    },

    //-------------------------------------------
    wellStatus: { // create/edit are assigned via WellStatusViewModel.js
        icon: { small: "sprite-editDocument-16" },
        open: { remove: deleteActionHandler },
        type: "Well Status",
        typeId: "D2BFB20B-6048-4612-9026-F963E3979721"
    },

    //-------------------------------------------
    wellType: buildPicklistOpen({ dataCacheId: "wellType", type: "Well Type", typeId: "8bb06972-3d0d-4257-abb1-472f7f91919e" }),

    //-------------------------------------------
    wiPartner: {
        open: {
            addToProject: buildAddToProjectWindowHandler()
        }
    },

    //-------------------------------------------
    zone: buildPicklistOpen({ dataCacheId: "zone", type: "Zone", typeId: "1c29f243-f22a-4106-9c8a-4fb431523f36" }),

    //-------------------------------------------
    zoneBase: buildFilterPicklistData({ dataCacheId: "zone", displayName: "Zone Base", name: "zoneBase", applyFilter: function (item) { return (item[2] !== "true"); } })

};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = pli.config.entityRegistry = registry;



//////////////////
// WEBPACK FOOTER
// ./app/entity-registry/entityRegistry.js
// module id = 493
// module chunks = 49